<div class="hint-with-indicator" *ngIf="indicatorType">
    <div class="hint-with-indicator__inner">
        <shared-loader-for-spinner class="hint-with-indicator__indicator -type-loading"
            *ngIf="indicatorType === 'loading'" [size]="size"></shared-loader-for-spinner>

        <shared-indicator class="hint-with-indicator__indicator -type-disabled" *ngIf="indicatorType === 'disabled'"
            [feel]="feelDisabled" [size]="size" [icon]="iconDisabled" [inverted]="inverted">{{textDisabled}}
        </shared-indicator>

        <shared-indicator class="hint-with-indicator__indicator -type-success" *ngIf="indicatorType === 'success'"
            [feel]="feelPositive" [size]="size" [icon]="iconPositive" [inverted]="inverted">{{textPositive}}
        </shared-indicator>

        <shared-indicator class="hint-with-indicator__indicator -type-danger" *ngIf="indicatorType === 'danger'"
            [feel]="feelNegative" [size]="size" [icon]="iconNegative" [inverted]="inverted">{{textNegative}}
        </shared-indicator>

        <div class="hint-with-indicator__messages -type-danger" *ngIf="indicatorType === 'danger' && messages">
            <shared-hints-floating [size]="hintsSize" [feel]="hintsFeel" [vSide]="hintsVSide" [hSide]="hintsHSide"
                (onButtonClick)="handleFloatingButtonClick($event)" [button]="button" [messages]="messages">
            </shared-hints-floating>
        </div>

    </div>
</div>